/**
 * AppConfig DTOs
 *
 * Data Transfer Objects for app configuration
 */

export interface AppConfigDTO {
  id: number;
  appName: string;
  appTagline?: string;
  // Light mode logos
  logoOriginalUrl?: string;
  logoFaviconUrl?: string;
  logoSmallUrl?: string;
  logoMediumUrl?: string;
  logoLargeUrl?: string;
  // Dark mode logos
  logoDarkOriginalUrl?: string;
  logoDarkFaviconUrl?: string;
  logoDarkSmallUrl?: string;
  logoDarkMediumUrl?: string;
  logoDarkLargeUrl?: string;
  primaryColor?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface UpdateAppConfigDTO {
  appName?: string;
  appTagline?: string;
  // Light mode logos
  logoOriginalUrl?: string | null;
  logoFaviconUrl?: string | null;
  logoSmallUrl?: string | null;
  logoMediumUrl?: string | null;
  logoLargeUrl?: string | null;
  // Dark mode logos
  logoDarkOriginalUrl?: string | null;
  logoDarkFaviconUrl?: string | null;
  logoDarkSmallUrl?: string | null;
  logoDarkMediumUrl?: string | null;
  logoDarkLargeUrl?: string | null;
  primaryColor?: string;
}

/**
 * Default config values
 */
export const DEFAULT_APP_CONFIG: AppConfigDTO = {
  id: 1,
  appName: 'KREVX',
  appTagline: 'El futuro de la educación online',
  primaryColor: '#7C3AED',
};
